export default "__VITE_PUBLIC_ASSET__28aa5d30__"